__turbopack_context__.v({
  "active": "mochi-input-module-scss-module__basVAG__active",
  "before-value": "mochi-input-module-scss-module__basVAG__before-value",
  "clear": "mochi-input-module-scss-module__basVAG__clear",
  "container": "mochi-input-module-scss-module__basVAG__container",
  "dark-mode": "mochi-input-module-scss-module__basVAG__dark-mode",
  "disabled": "mochi-input-module-scss-module__basVAG__disabled",
  "error": "mochi-input-module-scss-module__basVAG__error",
  "error-message": "mochi-input-module-scss-module__basVAG__error-message",
  "floating": "mochi-input-module-scss-module__basVAG__floating",
  "grey": "mochi-input-module-scss-module__basVAG__grey",
  "input": "mochi-input-module-scss-module__basVAG__input",
  "light-mode": "mochi-input-module-scss-module__basVAG__light-mode",
  "mochi-input": "mochi-input-module-scss-module__basVAG__mochi-input",
  "normal": "mochi-input-module-scss-module__basVAG__normal",
  "round": "mochi-input-module-scss-module__basVAG__round",
});
